import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { IMAGE_TRANSLATIONS } from '../constants/image-translations'
import type { Language } from '../types/common'

const useTranslateImage = () => {
  const { i18n } = useTranslation()
  const { language } = i18n

  const translateImage = useCallback(
    (imageKey: keyof typeof IMAGE_TRANSLATIONS) => {
      return IMAGE_TRANSLATIONS[imageKey][language as Language]
    },
    [],
  )

  return translateImage
}

export default useTranslateImage
